module.exports = __webpack_public_path__ + "static/img/wechat.44f3d780.png";